import { Divider, Typography } from "@mui/material";

export const SubGroup = ({ label, isBlock, isError }) => (
  <Divider
    textAlign="left"
    sx={{
      "&:before": { width: 16 }
    }}
  >
    <Typography color={!!isError ? isError : isBlock ? "secondary" : "primary"}>{label}</Typography>
  </Divider>
);
